import { on, select, selectAll, removeClass, addClass, hasClass } from 'modules/dom'
import { map } from 'modules/utils'

const IMAGE_ASSESSMENTS_SELECTOR = '.js-assessments-image'
const TAB_ASSESSMENTS_SELECTOR = '.js-assessments-tab'
const SCROLL_INDICATOR_SELECTOR = '.js-scroll-indicator'

const IMAGE_ASSESSMENTS_ACTIVE_CLASS = 'two-up-assessments__image--active'
const TAB_ASSESSMENTS_ACTIVE_CLASS = 'two-up-assessments__tab--active'

export default function(el) {
  const tabAssessmentsEls = selectAll(TAB_ASSESSMENTS_SELECTOR, el)
  const scrollIndicator = select(SCROLL_INDICATOR_SELECTOR, el)

  const updateScrollIndicator = (el) => {
    scrollIndicator.style.maxHeight = `${el.offsetHeight}px`
    scrollIndicator.style.top = `${el.offsetTop}px`
  }

  const setActiveImage = (id) => {
    const imageAssessmentsEls = selectAll(IMAGE_ASSESSMENTS_SELECTOR, el)
    if (imageAssessmentsEls.length) {
      map(imageAssessmentsEl => {
        removeClass(IMAGE_ASSESSMENTS_ACTIVE_CLASS, imageAssessmentsEl)
        imageAssessmentsEl.getAttribute('data-assessment-id') == id && addClass(IMAGE_ASSESSMENTS_ACTIVE_CLASS, imageAssessmentsEl)
      }, imageAssessmentsEls)
    }
  }

  if (tabAssessmentsEls.length) {
    map((tabAssessmentsEl) => {
      hasClass(TAB_ASSESSMENTS_ACTIVE_CLASS, tabAssessmentsEl) && updateScrollIndicator(tabAssessmentsEl)

      on('click', function () {
        const tabId = this.getAttribute('data-assessment-id')

        removeClass(TAB_ASSESSMENTS_ACTIVE_CLASS, tabAssessmentsEls)
        addClass(TAB_ASSESSMENTS_ACTIVE_CLASS, this)
        setActiveImage(tabId)
        updateScrollIndicator(this)
      }, tabAssessmentsEl)
    }, tabAssessmentsEls)
  }

  window.onresize = (e) => {
    map((tabAssessmentsEl) => {
      hasClass(TAB_ASSESSMENTS_ACTIVE_CLASS, tabAssessmentsEl) && updateScrollIndicator(tabAssessmentsEl)
    }, tabAssessmentsEls)
  }
}
